import { Trans } from '@lingui/react/macro';
import { Checkmark, InformationCircle } from '@remarkable/ark-icons';
import { Typography } from '@remarkable/ark-web';
import {
  IntegrationIssueType,
  type IntegrationIssue,
} from 'src/api/endpoints/cloudApi.types';

export const getIssueCopy = (issue: IntegrationIssue) => {
  switch (issue.type) {
    case IntegrationIssueType.NO_CONNECT: {
      return <Trans>Activate your Connect subscription</Trans>;
    }
    case IntegrationIssueType.PROVIDER_REVOKED_ACCESS: {
      return <Trans>Renew access by logging in to your service</Trans>;
    }
    case IntegrationIssueType.NO_ACCESSIBLE_CALENDAR: {
      return <Trans>This calendar isn't accessible</Trans>;
    }
    case IntegrationIssueType.ADMIN_APPROVAL: {
      return <Trans>Waiting for approval from your IT administrator</Trans>;
    }
    case IntegrationIssueType.POLICY_RESTRICTION: {
      return <Trans>Access is restricted by your IT administrator</Trans>;
    }
    default:
      return <Trans>Something went wrong</Trans>;
  }
};

interface IntegrationStatusProps {
  issues?: IntegrationIssue[] | null;
}

export const IntegrationStatus = ({ issues }: IntegrationStatusProps) => {
  if (!issues || issues.length < 1) {
    return (
      <div className="flex flex-nowrap items-center gap-8">
        <Checkmark
          size={18}
          className="-translate-y-px text-highlighter-green"
        />

        <Typography variant="body-sm" fontWeight="regular">
          <Trans>Active</Trans>
        </Typography>
      </div>
    );
  }
  return (
    <div className="flex flex-nowrap items-center gap-8">
      <InformationCircle
        className="-translate-y-px text-interaction-danger"
        size={18}
      />
      <Typography variant="body-sm" fontWeight="regular">
        <Trans>Inactive</Trans>
      </Typography>
    </div>
  );
};
